import type { ConversionProgress } from '../converter/conversion-controller'

/**
 * Renders the progress screen with a progress bar, page counter,
 * percentage, and a cancel button. Returns an update function
 * that the conversion controller calls to report progress.
 */
export function createProgressDisplay(
  container: HTMLElement,
  onCancel: () => void,
): (progress: ConversionProgress) => void {
  container.innerHTML = `
    <div class="progress-panel">
      <h2 class="progress-title">Converting your PDF</h2>
      <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
        <div class="progress-bar__fill" id="progressFill"></div>
      </div>
      <p class="progress-text" id="progressText">Starting...</p>
      <button type="button" class="cancel-button" id="cancelButton">Cancel</button>
    </div>
  `

  const fill = container.querySelector<HTMLDivElement>('#progressFill')!
  const text = container.querySelector<HTMLParagraphElement>('#progressText')!
  const bar = container.querySelector<HTMLDivElement>('.progress-bar')!
  const cancelButton =
    container.querySelector<HTMLButtonElement>('#cancelButton')!

  cancelButton.addEventListener('click', onCancel)

  return (progress: ConversionProgress) => {
    const percent = progress.total > 0
      ? Math.round((progress.completed / progress.total) * 100)
      : 0

    fill.style.width = `${percent}%`
    bar.setAttribute('aria-valuenow', String(percent))
    text.textContent =
      progress.completed >= progress.total
        ? 'Finalizing...'
        : `Page ${progress.currentPage} of ${progress.total} · ${percent}%`
  }
}
